/* Confezione regalo nel carrello (pagina e cassetto).
   Spunta = aggiunge/toglie il prodotto-servizio dal carrello (riga vera,
   col suo prezzo). Messaggio = attributo dell'ordine "Messaggio regalo",
   salvato al volo mentre si scrive.
   Listener delegati sul documento: il cassetto ridisegna il proprio
   contenuto via AJAX e i nodi vengono sostituiti, la delega sopravvive. */
(function () {
  if (window.bdrRegaloAttivo) return; /* il file può essere incluso due volte */
  window.bdrRegaloAttivo = true;

  var timer = null;

  function radiceDa(el) {
    return el.closest('bdr-confezione-regalo');
  }

  function avvisa(radice, msg) {
    var nota = radice.querySelector('.bdr-regalo__nota');
    if (nota) nota.textContent = msg || '';
  }

  /* Nel cassetto: ridisegna il contenuto con la section rendering API,
     come fa Dawn, senza ricaricare la pagina. Sulla pagina carrello:
     ricarica (vanno aggiornate righe e totali renderizzati server-side). */
  function aggiorna(radice) {
    var drawer = radice.closest('cart-drawer');
    if (!drawer) {
      window.location.reload();
      return;
    }
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sezioni) {
        var doc = new DOMParser().parseFromString(sezioni['cart-drawer'], 'text/html');
        var nuovo = doc.querySelector('#CartDrawer');
        var attuale = document.querySelector('#CartDrawer');
        if (nuovo && attuale) attuale.innerHTML = nuovo.innerHTML;
        var bolla = document.querySelector('#cart-icon-bubble');
        if (bolla && sezioni['cart-icon-bubble']) {
          var docBolla = new DOMParser().parseFromString(sezioni['cart-icon-bubble'], 'text/html');
          var nuovaBolla = docBolla.querySelector('.shopify-section');
          if (nuovaBolla) bolla.innerHTML = nuovaBolla.innerHTML;
        }
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('change', function (e) {
    var check = e.target.closest('.bdr-regalo__check');
    if (!check) return;
    var radice = radiceDa(check);
    var varianteId = parseInt(radice.dataset.variante, 10);
    check.disabled = true;

    var richiesta;
    if (check.checked) {
      richiesta = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: varianteId, quantity: 1 })
      });
    } else {
      richiesta = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: varianteId.toString(), quantity: 0 })
      });
    }
    richiesta
      .then(function (r) {
        if (!r.ok) throw new Error('risposta ' + r.status);
        aggiorna(radice);
      })
      .catch(function () {
        check.checked = !check.checked;
        check.disabled = false;
        avvisa(radice, radice.dataset.msgErrore);
      });
  });

  document.addEventListener('input', function (e) {
    var testo = e.target.closest('.bdr-regalo__textarea');
    if (!testo) return;
    var radice = radiceDa(testo);
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Messaggio regalo': testo.value.trim() } })
      })
        .then(function (r) {
          avvisa(radice, r.ok ? radice.dataset.msgSalvato : radice.dataset.msgErroreSalvataggio);
        })
        .catch(function () {
          avvisa(radice, radice.dataset.msgErroreSalvataggio);
        });
    }, 600);
  });
})();
